// Abbreviazioni team: mappa nome completo -> sigla (per evitare "AC" da "AC Milan" etc.)
// Usato in profile (CardItem) e marketplace (AuctionCard)
const TEAM_ABBR_OVERRIDES = {
  'ac milan': 'MIL',
  'acm': 'MIL',
  'inter': 'INT',
  'juventus': 'JUV',
  'juve': 'JUV',
  'roma': 'ROM',
  'as roma': 'ROM',
  'lazio': 'LAZ',
  'ss lazio': 'LAZ',
  'napoli': 'NAP',
  'ssc napoli': 'NAP',
  'atalanta': 'ATA',
  'atalanta bc': 'ATA',
  'fiorentina': 'FIO',
  'acf fiorentina': 'FIO',
  'torino': 'TOR',
  'bologna': 'BOL',
  'bologna fc': 'BOL',
  'sassuolo': 'SAS',
  'udinese': 'UDI',
  'udinese calcio': 'UDI',
  'hellas verona': 'VER',
  'verona': 'VER',
  'genoa': 'GEN',
  'genoa cfc': 'GEN',
  'cagliari': 'CAG',
  'cagliari calcio': 'CAG',
  'empoli': 'EMP',
  'empoli fc': 'EMP',
  'lecce': 'LEC',
  'us lecce': 'LEC',
  'monza': 'MON',
  'ac monza': 'MON',
  'frosinone': 'FRO',
  'frosinone calcio': 'FRO',
  'real madrid': 'RMA',
  'madrid': 'RMA',
  'barcelona': 'BAR',
  'fc barcelona': 'BAR',
  'atletico madrid': 'ATM',
  'atletico': 'ATM',
  'manchester united': 'MUN',
  'man united': 'MUN',
  'manchester city': 'MCI',
  'man city': 'MCI',
  'liverpool': 'LIV',
  'liverpool fc': 'LIV',
  'chelsea': 'CHE',
  'chelsea fc': 'CHE',
  'arsenal': 'ARS',
  'arsenal fc': 'ARS',
  'tottenham': 'TOT',
  'tottenham hotspur': 'TOT',
  'bayern munich': 'BAY',
  'bayern': 'BAY',
  'borussia dortmund': 'BVB',
  'dortmund': 'BVB',
  'paris saint-germain': 'PSG',
  'psg': 'PSG',
  'paris sg': 'PSG',
};

export function getTeamAbbr(teamName) {
  if (!teamName || typeof teamName !== 'string') return '';
  const trimmed = teamName.trim();
  if (!trimmed) return '';
  const key = trimmed.toLowerCase();
  if (TEAM_ABBR_OVERRIDES[key]) return TEAM_ABBR_OVERRIDES[key];
  const words = trimmed.split(/\s+/).filter((w) => w.length > 2 || !/^(ac|as|fc|cf|ss|us|cfc|bc)$/i.test(w));
  const lastWord = words.length ? words[words.length - 1] : trimmed;
  const take = lastWord.length <= 4 ? lastWord : lastWord.substring(0, 3);
  return take.toUpperCase();
}
